import React, { useEffect, useState} from "react";

import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";

import activeIcon from '../assect/icons/map-marker-active.png'
import inactiveIcon from '../assect/icons/map-marker-inactive.png'

const buidlings = [
    {
        key: "1",
        location: {
            lat: 42.729717,
            lng: -73.694157
        }
    },
    {
        key: "2",
        location: {
            lat: 42.714535,
            lng: -73.705861
        }
    },
    {
        key: "3",
        location: {
            lat: 42.714645,
            lng: -73.705786
        }
    },
    {
        key: "4",
        location: {
            lat: 42.727102,
            lng: -73.688807
        }
    }
]


const MapComponent = ({markers, selectedMapCoords}) => {
    const [map, setMap] = useState(null);
    const [center, setCenter] = useState({ lat: 42.7284, lng: -73.6918 });
    const [zoom, setZoom] = useState(14);
    const [markerPosition, setMarkerPosition] = useState([]);
    const [markerIcon, setMarkerIcon] = useState(null);
    
    const [oneSeventyTwoPointer, setOneSeventyTwoPointer] = useState(inactiveIcon);
    const [sevenZeroSixPointer, setSevenZeroSixPointer] = useState(inactiveIcon);
    const [sevenTenPointer, setSevenTenPointer] = useState(inactiveIcon);
    const [fourteenEightySevenPointer, setFourteenEightySevenPointer] = useState(inactiveIcon);
    
    const apiKey = 'AIzaSyCa-drt5kf6vDkxqbMlMdIWvnVNJAFx3sg';
    const mapId = '55503d787054ca81';
    
    useEffect(() => {
        
        if((markers !== null && markers !== undefined) && Array.isArray(markers)) 
        {
            // we have a populated inbound array of markers
            const newArray = [...markers];
            setMarkerPosition(newArray);
        }
    }, [])
    
    useEffect(() => {
        if(typeof selectedMapCoords === 'undefined')
            return;
        
        setOneSeventyTwoPointer(inactiveIcon);
        setSevenZeroSixPointer(inactiveIcon);
        setSevenTenPointer(inactiveIcon);
        setFourteenEightySevenPointer(inactiveIcon);
        
        if(selectedMapCoords.lat === 42.729717 &&  selectedMapCoords.lng === -73.694157)
            setOneSeventyTwoPointer(activeIcon);

        if(selectedMapCoords.lat === 42.714535 &&  selectedMapCoords.lng === -73.705861)
            setSevenZeroSixPointer(activeIcon);

        if(selectedMapCoords.lat === 42.714645 &&  selectedMapCoords.lng === -73.705786)
            setSevenTenPointer(activeIcon);

        if(selectedMapCoords.lat === 42.727102 &&  selectedMapCoords.lng === -73.688807)
            setFourteenEightySevenPointer(activeIcon);

    }, [selectedMapCoords]);
    
    
    const onLoad = (map) => {
        setMap(map);
    }
    
    const onUnMount = () => {
        setMap(null);
    }
    
    const handleMapClick = (event) => {
        setMarkerPosition({ lat: event.latlng.lat(), lng: event.latlng.lng() });
    }
    
    return (
            <APIProvider apiKey={apiKey}>
                <Map
                    mapId={mapId}
                    style={{ height: '500px', width: '100%' }}
                    defaultCenter={center}
                    defaultZoom={zoom}
                >
                        <AdvancedMarker key="172 River Street"  position={{
                            lat: 42.729717,
                            lng: -73.694157
                        }}>
                            <img src={oneSeventyTwoPointer} alt='Inactive Marker' />
                        </AdvancedMarker>/

                        <AdvancedMarker key="706 3rd Avenue" position={{
                            lat: 42.714535,
                            lng: -73.705861
                            }}>
                            <img src={sevenZeroSixPointer} alt='Inactive Marker' />
                        </AdvancedMarker>/
                        <AdvancedMarker key="710 3rd Ave" position={{
                            lat: 42.714645,
                            lng: -73.705786
                        }}>
                            <img src={sevenTenPointer} alt='Inactive Marker' />
                        </AdvancedMarker>/
                    
                        <AdvancedMarker key="1487 5th Avenue" position={{
                            lat: 42.727102,
                            lng: -73.688807
                        }}>
                            <img src={fourteenEightySevenPointer} alt='Inactive Marker' />
                        </AdvancedMarker>/
                </Map>
            </APIProvider> 
     );
    
}

export default MapComponent;

